<template>
    <div>
        <div class="my-plan" v-if="active_subscription">
            <div class="plan">
                <p class="my-plan_ttl">{{ active_subscription.plan_title }}</p>
                <p class="my-plan_price">${{ active_subscription.price_per_month }} per month</p>
            </div>
            <div class="buttons-bottom">
                <a href="javascript:void(0)" class="btn btn-transparent-wb mr-4" data-toggle="modal" data-target="#cancelConfirmModal">Cancel</a>
                <a href="javascript:void(0)" class="btn" @click="showChangePlanConfirmation">Change Plan</a>
            </div>
        </div>

        <SubscriptionPlanSelect
            v-else
            :inner_plans="plans"
            @create="subscribe"
        >
        </SubscriptionPlanSelect>

        <SubscriptionPlanListModal
            ref="subscriptionPlanListModal"
            :input_plans="plans"
            :input_active_subscription="active_subscription"
            @upgrade="subscribe"
            @cancel="cancel"
        >
        </SubscriptionPlanListModal>

        <SubscriptionCancelModal @cancel-subscription="cancelPlan"/>
        <SubscriptionChangeModal @change-subscription="showPlansModal"/>
    </div>
</template>

<script>
    import SubscriptionCancelModal from "./SubscriptionCancelModal.vue";
    import SubscriptionChangeModal from "./SubscriptionChangeModal.vue";
    import SubscriptionPlanListModal from "./SubscriptionPlanListModal";
    import SubscriptionPlanSelect from "./SubscriptionPlanSelect";

    export default {
        name: "SubscriptionPlanShow",
        components: {
            SubscriptionCancelModal,
            SubscriptionChangeModal,
            SubscriptionPlanListModal,
            SubscriptionPlanSelect,
        },
        props: {
            input_plans: {
                type: Array,
                required: false
            },
            user_active_subscription: {
                type: Object,
                required: false,
                validator: prop => typeof prop === 'object' || prop === null
            },
        },
        data() {
            return {
                plans: this.input_plans,
                active_subscription: this.user_active_subscription,
            }
        },
        methods: {
            cancelPlan() {
                axios.delete(`/subscription/cancel/${this.active_subscription.id}`)
                    .then(response => {
                        console.log(response);

                        this.active_subscription = null;
                    })
                    .catch(error => {
                        this.$swal.fire({
                            title: `Can not add your subscription!`,
                            text: error.response.data.message,
                            icon: 'error',
                        });
                    })

                $('#cancelConfirmModal').modal('hide');
                $('#cancelSuccessModal').modal();
            },
            cancel() {
                this.active_subscription = null;
                this.$refs.subscriptionPlanListModal.active_subscription = null;
            },
            showChangePlanConfirmation() {
                $('#changeConfirmModal').modal();
            },
            showPlansModal() {
                $('#changeConfirmModal').modal('hide');
                $('#changePlanModal').modal();
            },
            subscribe(subscription) {
                this.active_subscription = subscription;
                this.$refs.subscriptionPlanListModal.active_subscription = subscription;
            }
        }
    }
</script>

